import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { LuSearch, LuShoppingCart, LuX, LuMenu } from 'react-icons/lu';

// DS
import {
  VertContainer,
  VertDrawer,
  VertModal,
  VertTypography,
} from '@vertem-core/vertice-ds';

import Icon from 'components/Atoms/Icons/Icon';
import SearchContainer from 'components/Search/SearchContainer';

// STYLES
import 'Assets/styles/default/components/Header/HeaderStyles.less';
import HeaderProfile from './HeaderProfile';
import HeaderPoints from './HeaderPoints';
import HeaderMenuDefaultMobile from 'structure/Menu/DefaultMobile';
import { useNotifications } from '../../../Shared/Notification';
import { Link } from 'react-router-dom';
import VertNotifications from 'components/VertNotification';
import ynToBool from 'Utils/ynToBool';

// HEADER MOBILE COMPONENT
const HeaderMobile = ({
  logo,
  openCloseCartDrawerHandler,
  quantityItemsCart,
}) => {
  const { notifications } = useNotifications();

  /* States */
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const [isOpenSearch, setIsOpenSearch] = useState(false);
  /* Vars */
  const headerMobileMenuIcon = isOpenMenu ? LuX : LuMenu;

  /* Handlers */
  const openCloseMenuHandler = () => {
    setIsOpenMenu(!isOpenMenu);
  };

  const openCloseSearchHandler = () => {
    setIsOpenSearch(!isOpenSearch);
  };

  /* Utils */
  const accordionMenuItems = (items) => {
    return (
      <div className="content-content-items">
        {items.map((item) => (
          <VertTypography.Paragraph className="accordion-item" key={item.key}>
            <a href={`${item.href}`} data-label={item.label}>
              {item.label}
            </a>
          </VertTypography.Paragraph>
        ))}
      </div>
    );
  };

  const headerMobileMenuContent = (
    <VertDrawer
      open={isOpenMenu}
      className="header-mobile-menu"
      onClose={openCloseMenuHandler}
      placement="left"
    >
      <div className="header-mobile-menu-content">
        <div className="header-profile">
          <HeaderProfile />
          <HeaderPoints />
        </div>

        <HeaderMenuDefaultMobile />
      </div>
    </VertDrawer>
  );

  useEffect(() => {
    if (isOpenMenu) {
      openCloseMenuHandler();
    }
  }, [location?.href]);

  const allHideMenus =
    ynToBool(process.env.REACT_APP_HIDE_SEARCH_BOX) &&
    ynToBool(process.env.REACT_APP_HIDE_NOTIFICATIONS) &&
    ynToBool(process.env.REACT_APP_HIDE_CART);

  /* Renders */
  return (
    <VertContainer fluid={true} className="header-mobile-container">
      <div
        className="header-main-content"
        style={{
          justifyContent: allHideMenus ? 'flex-start' : 'space-between',
          alignItems: 'center',
        }}
      >
        <div className="header-menu-icon">
          <Icon
            onClick={openCloseMenuHandler}
            component={headerMobileMenuIcon}
            className="lucide"
            size={`18px`}
            aria-label="Menu"
            role="button"
          />
        </div>

        <div className="header-logo">
          <Link to={'/'} title="Ir para página inicial">
            <img src={logo} alt={`logotipo ${process.env.REACT_APP_TITLE}`} />
          </Link>
        </div>
        {!ynToBool(process.env.REACT_APP_HIDE_SEARCH_BOX) && (
          <div className="header-search-icon">
            <Icon
              className="lucide"
              size={`18px`}
              component={LuSearch}
              onClick={openCloseSearchHandler}
              aria-label="O que você está buscando?"
              role="button"
            />
          </div>
        )}

        {!ynToBool(process.env.REACT_APP_HIDE_NOTIFICATIONS) && (
          <div className="header-notifications-icon">
            <VertNotifications
              template="marketplace"
              items={notifications
                ?.filter((item) => item.toJSON)
                ?.map((item) => item.toJSON())}
              aria-label="Notificações"
              role="button"
              active
              isMobile
            />
          </div>
        )}
        {!ynToBool(process.env.REACT_APP_HIDE_CART) && (
          <div className="header-checkout-icon">
            <Icon
              className="lucide"
              size={`18px`}
              component={LuShoppingCart}
              aria-label="Carrinho"
              role="button"
              onClick={openCloseCartDrawerHandler}
            />
            <div className="vert-header-checkout-badge">
              <span className="header-checkout-badge">{quantityItemsCart}</span>
            </div>
          </div>
        )}
      </div>
      {!ynToBool(process.env.REACT_APP_HIDE_CONTENT_POINTS) && (
        <HeaderPoints isProfile={false} />
      )}

      {isOpenSearch && (
        <VertModal
          open={isOpenSearch}
          className="header-mobile-search-modal"
          onCancel={openCloseSearchHandler}
        >
          <div className="header-mobile-search">
            <SearchContainer openCloseSearchHandler={openCloseSearchHandler} />
          </div>
        </VertModal>
      )}

      {isOpenMenu && headerMobileMenuContent}
    </VertContainer>
  );
};

HeaderMobile.propTypes = {
  logo: PropTypes.string,
  menuItems: PropTypes.object,
  openCloseCartDrawerHandler: PropTypes.func,
  searchButtonHandler: PropTypes.func,
  quantityItemsCart: PropTypes.number,
};

export default HeaderMobile;
